import { Directive, ElementRef, HostListener } from "@angular/core";
@Directive({
    selector: "[lowercase-inp]",
})
export class LowercaseInpDirective {
    constructor(public ref: ElementRef) {}

    @HostListener("focusout", ["$event"]) onBlur($event) {
        $event.target.value = $event.target.value.toLowerCase();
        const evt = new Event("input");
        $event.target.dispatchEvent(evt);
    }
}
